export interface Campaign {
	id: string;
	created: string;
	status: CampaignStatus;
	stockId: string;
	subject: string;
	// CombinedTicker: string;
	// Names: CampaignContactNameItem[];
	isTest: boolean;
	// EmailMarketingApiArgs: EmailMarketingApiArgs;
	// Template: string;
}

export enum CampaignStatus {
	None="None",
	Draft="Draft",
	Sent="Sent",
	Queued="Queued",
}